import "./banner.css";
function Banner() {
  return (
    <div className="banner">
      <h1 className="font-face-bp">Hady Hesham</h1>
      <p className="font-face-bp">Front-end Developer</p>
    </div>
  );
}

export default Banner;
